import { get } from 'svelte/store';
import client, { PRIVATE_CLIENT } from '../../services/client';
import authStore from '../../store/auth';
export const getQueues = async (business_id, page = 1) => {
    const { user } = get(authStore);
    return await client.get(`business/${business_id}/call-queue/agent/${user.id}/`, PRIVATE_CLIENT, null, {
        page_index: page
    });
};
export const getQueueContacts = async (business_id, queue_id, page = 1) => {
    const { user } = get(authStore);
    return await client.get(`business/${business_id}/call-queue/${queue_id}/agent/${user.id}/items/`, PRIVATE_CLIENT, null, {
        page_index: page
    });
};
export const removeFromQueue = async (business_id, queue_id, __contacts__ = null) => {
    const { user } = get(authStore);
    const contacts = !__contacts__ ? [] : __contacts__ && !Array.isArray(__contacts__) ? [__contacts__] : __contacts__;
    return await client.delete(`business/${business_id}/call-queue/${queue_id}/agent/${user.id}/items/`, PRIVATE_CLIENT, {
        contacts
    });
};
